import {Component, Input} from '@angular/core';
import {ReportUserGenerated} from "../../../../core/model-store/models/report-user-generated";

@Component({
    selector: 'grid-report',
    templateUrl: './grid-report.component.html',
    styleUrls: ['./grid-report.component.scss'],
    standalone: false
})
export class GridReportComponent {

  @Input() reportTemplate: ReportUserGenerated;
  @Input() extractedArtifacts: any;
  @Input() viewOptionsCheckboxValues: any;
  @Input() preview: boolean = false;
  @Input() numColumnsInReport = 2;

  isPromptSelected() {
    return this.viewOptionsCheckboxValues.find((option) => option.key === 'vis_ledetekster')?.value;
  }

  isOnlyPhotosSelected() {
    return this.viewOptionsCheckboxValues.find((option) => option.key === 'kun_bilder')? this.viewOptionsCheckboxValues.find((option) => option.key === 'kun_bilder').value : false;
  }

}
